import React from 'react';
import { LoadingItemsProps } from './LoadingItems';

export const LoadingItemsLavenderBlue1: React.FC<LoadingItemsProps> = () => (
  <svg width='211' height='21' viewBox='0 0 211 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M85.9155 10.414C85.9155 16.1661 81.2537 20.828 75.5015 20.828C69.7494 20.828 65.0875 16.1661 65.0875 10.414C65.0875 4.66186 69.7494 0 75.5015 0C81.2537 0 85.9155 4.66186 85.9155 10.414Z'
      fill='#1E22AA'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M145.023 20.828V10.0906V7.66566V7.65423C145.017 3.44429 141.874 0 138.032 0C134.192 0 131.047 3.44429 131.043 7.65423V7.66566V10.0906V20.828H145.023Z'
      fill='#1E22AA'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M200.468 0L190.056 20.828H210.884L200.468 0Z'
      fill='#1E22AA'
    />
    <path d='M12.5109 4.92857L22.0054 0.696598L21.9727 9.23309L12.5109 4.92857Z' fill='#1E22AA' />
    <path d='M12.6203 4.95946L3.19629 9.27653L3.15215 0.740086L12.6203 4.95946Z' fill='#1E22AA' />
    <rect x='3.18616' y='4.93652' width='18.8016' height='16.0635' fill='#1E22AA' />
  </svg>
);
